import gql from 'graphql-tag';
import { buildConnectionQuery } from "../../helpers.class";

const userFragment = `
  id
  email
  firstName
  middleName
  lastName
`;

const investigationCurrentFragment = `
  UnBilledEntries
  TimeDairyIcon
  DocumentUploaded
  DocumentSent
  EvidenceUploaded
  PhotosUploaded
  PastEvents
  ReportsWithStatus {
    document {
      title
      status
    }
    latestSnapshot {
      createdAt
    }
    type
  }
  InvestigationMarkClose {
    id
    markClosed
  }
  Detail {
    id
    waitingForDocusketch
  }
`;

const nodeFragment = `
  id
  notes
  authorizedBy
  Investigation {
    id
    nefcoNumber
    lossDate
    createdAt
    LossAddress {
      id
      address1
      address2
      address3
      city
      state
      postal
      country
      TypeId
      Type {
        id
        name
      }
    }
    status
    Client {
      id
    }
    Priority {
      id
      name
    }
    InvestigationStaff {
      id
      User {
        id
        firstName
        middleName
        lastName
        email
      }
      Role {
        id
        title
      }
    }
    Comments {
      id
      text
      adminOnly
      createdAt
      CreatedBy { ${userFragment} }
    }
    ${investigationCurrentFragment}
  }
  Status
  StatusHistory {
    id
    name
    comment
    CreatedBy {
      id
      firstName
      middleName
      lastName
    }
    createdAt
  }
  Contact {
    id
  }
  CreatedBy {
    id
    firstName
    middleName
    lastName
  }
  RequestType {
    id
    name
  }
  Address {
    id
    address1
    address2
    city
    state
    postal
    country
  }
  createdAt
  updatedAt
`;

export const requestsConnectionQuery = gql`${buildConnectionQuery("Request", "requestsConnection", nodeFragment)}`;

export const addRequestMutation = gql`mutation createRequest($input: AddRequestInput!) {
  addRequest(input: $input) { ${nodeFragment} }
  }`;

export const removeRequestMutation = gql`mutation RemoveRequest($id: ID!) {
  removeRequest(id: $id)
}`;

export const updateRequestMutation = gql`mutation updateRequest($input: UpdateRequestInput!) {
  updateRequest(input: $input) { ${nodeFragment} }
}`;

export const getRequestByIdQuery = gql`query getRequestById($id: ID!) {
  getRequestById(id: $id) {${nodeFragment}}
}`;

export const reactivateInvestigationMutation = gql`mutation ReactivateInvestigation($input: ReactivateInvestigationInput!) {
  reactivateInvestigation(input: $input)
}`;
